const basketList = [
    {
        id: 0,
        title: "Shell, 2022",
        image: require("./assets/basket-2.webp"),
        measurement: '11cm x 25.8cm',
        description: 'white clay, iron oxide, copper oxide, coffee glaze'

    },
    {
        id: 1,
        title: "Maro’s Garden Diptych, 2022",
        image: require("./assets/basket-8.JPG"),
        measurement: '6.2cm x 29.5cm each',
        description: 'white clay, copper oxide, turquoise lead glaze'

    },
    {
        id: 2,
        title: "Cuttle Fish, 2023",
        image: require("./assets/basket-5.webp"),
        measurement: '6cm x 40cm',
        description: 'white clay, copper oxide, clear glaze'

    },
    {
        id: 3,
        title: "Sap Spurt, 2022",
        image: require("./assets/basket-6.webp"),
        measurement: '4cm x 39.5cm',
        description: 'red stoneware, white slip, copper oxide'
        

    },
     {
        id: 4,
        title: "Olive Basket, 2023",
        image: require("./assets/basket-7.webp"),
        measurement: '8cm x 24cm',
        description: 'white clay, iron oxide, coffee glaze'

    },
    {
        id: 5,
        title: "Cypress Tree, 2022",
        image: require("./assets/basket-1.webp"),
        measurement: '3.5 cm x 37',
        description: 'white clay, copper oxide, clear glaze'

    },
  


]

export default basketList;